import {
  ENROLLMENT_ROLE_EDITOR,
  ENROLLMENT_ROLE_FACILITATOR,
  ENROLLMENT_ROLE_OBSERVER,
  ENROLLMENT_ROLE_STUDENT,
  ENROLLMENT_ROLE_TEACHER
} from "./constants"

// TODO: add `translator` to translation extraction processing
export const getRegistrationRoleLabel = (role, translator) => {
  switch (role) {
    case ENROLLMENT_ROLE_OBSERVER:
      return translator("observer")
    case ENROLLMENT_ROLE_STUDENT:
      return translator("learner")
    case ENROLLMENT_ROLE_FACILITATOR:
      return translator("moderator")
    case ENROLLMENT_ROLE_TEACHER:
      return translator("teacher")
    case ENROLLMENT_ROLE_EDITOR:
      return translator("course editor")
  }
}
